<div class="dialog-container">
  <h2 mat-dialog-title>{{ isEditMode ? 'Edit Login Info' : 'Create New Login Info' }}</h2>

  <mat-dialog-content>
    <form [formGroup]="loginInfoForm" class="login-info-form">
      <div class="form-section">
        <h3>Account Credentials</h3>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" type="email" placeholder="player@example.com">
          @if (loginInfoForm.get('email')?.invalid && loginInfoForm.get('email')?.touched) {
            <mat-error>
              @if (loginInfoForm.get('email')?.hasError('required')) {
                Email is required
              } @else if (loginInfoForm.get('email')?.hasError('email')) {
                Please enter a valid email
              }
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Password</mat-label>
          <input matInput formControlName="password" type="text" [placeholder]="isEditMode ? 'Leave empty to keep current password' : 'Account password'">
          @if (loginInfoForm.get('password')?.invalid && loginInfoForm.get('password')?.touched) {
            <mat-error>Password is required</mat-error>
          }
          @if (isEditMode) {
            <mat-hint>Leave empty if you don't want to change the password</mat-hint>
          }
        </mat-form-field>
      </div>

      <div class="form-section">
        <h3>Backup Codes</h3>

        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>Backup Code 1</mat-label>
            <input matInput formControlName="backup_code_1" (paste)="onBackupCodePaste($event, 1)" [placeholder]="isEditMode ? 'Optional' : 'Required'">
            @if (loginInfoForm.get('backup_code_1')?.invalid && loginInfoForm.get('backup_code_1')?.touched) {
              <mat-error>Backup code 1 is required</mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Backup Code 2</mat-label>
            <input matInput formControlName="backup_code_2" (paste)="onBackupCodePaste($event, 2)" placeholder="Optional">
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>Backup Code 3</mat-label>
            <input matInput formControlName="backup_code_3" (paste)="onBackupCodePaste($event, 3)" placeholder="Optional">
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Backup Code 4</mat-label>
            <input matInput formControlName="backup_code_4" (paste)="onBackupCodePaste($event, 4)" placeholder="Optional">
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>Backup Code 5</mat-label>
            <input matInput formControlName="backup_code_5" (paste)="onBackupCodePaste($event, 5)" placeholder="Optional">
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Backup Code 6</mat-label>
            <input matInput formControlName="backup_code_6" (paste)="onBackupCodePaste($event, 6)" placeholder="Optional">
          </mat-form-field>
        </div>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" [disabled]="loading">
      Cancel
    </button>
    <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="loading || loginInfoForm.invalid">
      @if (loading) {
        <mat-spinner [diameter]="20"></mat-spinner>
      } @else {
        {{ isEditMode ? 'Update' : 'Create' }}
      }
    </button>
  </mat-dialog-actions>
</div>
